function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.756 20.513a3.3 3.3 0 002.8-1.568 3.315 3.315 0 005.631 0A3.3 3.3 0 0012 20.513c1.46 0 3.871-2.216 5.381-3.769a.746.746 0 011.275.423c.1.927.477 1.846 1.591 1.846a3.344 3.344 0 003-2.25m-11.997 0L7.8 15.9a6 6 0 01-3.81-2.947L.75 7.013l22.5 4.5M6.107 8.084l5.143-2.571 9.75 1.5",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 10.763l1.5-3.75L22.568 4.4a.749.749 0 00-.643-1.136H19.5l-3.69 2.951",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgSeaTransportYacht(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgSeaTransportYacht;